<h3 class="color-primary" mat-dialog-title>{{data.title}}</h3>
<div mat-dialog-content>
	{{data.description}}
	<mat-form-field class="w-full">
		<input matInput [(ngModel)]="data.data" placeholder="{{data.placeholder}}">
	</mat-form-field>
</div>

<div mat-dialog-actions align="end">
	<button mat-button (click)="onNoClick()" color="danger">{{data.cancelbtn}}</button>&nbsp;
	<button mat-raised-button (click)="onYesClick()" cdkFocusInitial>{{data.confirmbtn}}</button>
</div>